import { useNavigate } from "react-router-dom";

import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import { useSession } from "0.Mine/2.Context/sessionContext";
import axiosInstance from "0.Mine/axiosInstance";

import { DaySchedule } from "../../3.Interfaces/Schedule";

export const useHandleBusinessSchedule = () => {
  const { session } = useSession();
  const navigate = useNavigate();
  if (!session) {
    navigate("/signin", { replace: true });
  }
  const userid = session.user.id;
  const token = session.user.token;

  const createBusinessSchedule = async (
    schedule: Record<string, DaySchedule>,
    businessId: number
  ) => {
    const payloadForQuery: Record<string, any> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
      data: JSON.stringify(schedule),
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.post(`POST/openingtimes.php?${queryString}`);

      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  const getBusinessSchedule = async (businessId: number) => {
    const payloadForQuery: Record<string, any> = {
      id: userid,
      token: token ?? "",
      businessid: businessId,
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.get(`GET/openingtimes.php?${queryString}`);
      console.log(response);
      if (response.data.data) {
        return response.data.data as Record<string, DaySchedule>;
      } else {
        return [];
      }
    } catch (error) {
      console.error(error);
    }
  };

  return { createBusinessSchedule, getBusinessSchedule };
};
